import React from 'react';
import PropTypes from 'prop-types';
import { FDClickableText } from '@facet-wealth/design';
import { hrefByRelationship } from 'Views/Page/Content/Templates';
import { assertSafeSpreadAttributes } from 'Packages/FacetCore/Experimental/helpers';
import { useNavigateByRelationshipOnClick } from 'Views/Page/Hooks/useNavigateByRelationshipOnClick';

export const ClickableTextRel = ({
  relationship,
  beforeOnClick,
  overrideOnClick,
  afterSuccessfulOnClick,
  loading,
  alignSelf,
  appearance,
  forceFocusMode,
  ...rest
}) => {
  const { onClick } = useNavigateByRelationshipOnClick(relationship, {
    beforeOnClick,
    overrideOnClick,
    afterSuccessfulOnClick,
    forceFocusMode,
  });

  assertSafeSpreadAttributes(rest);

  // The relationship could have been missing, in which case we shouldn't render
  if (!relationship) {
    return null;
  }

  return (
    <FDClickableText
      {...rest}
      label={relationship.meta('prompt')}
      onClick={onClick}
      alignSelf={alignSelf}
      appearance={appearance}
      href={hrefByRelationship(relationship)}
    />
  );
};

ClickableTextRel.defaultProps = {
  relationship: undefined,
  alignSelf: undefined,
  appearance: 'standalone',
};

ClickableTextRel.propTypes = {
  forceFocusMode: PropTypes.bool,
  relationship: PropTypes.object,
  alignSelf: PropTypes.oneOf(['flex-start', 'center', 'flex-end', undefined]),
  appearance: PropTypes.oneOf(['minor', 'standalone']),
};
